"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGFLockedOrderInfo = exports.useGFLockedOrderBasicInfo = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const useGFLockedOrderBasicInfo = (params) => {
    const { shouldPerformCalculation, exchangeOrder, curPrice, quoteCurPrice, totalProfitPercent: _totalProfitPercent } = params;
    const innerOrder = TradeAPILib_1.TradeUtils.getInnerOrder(exchangeOrder);
    const isRunning = exchangeOrder.isRunning;
    // 实际投资额
    const totalCost = (0, react_1.useMemo)(() => {
        var _a;
        if (shouldPerformCalculation) {
            // 实际投资额=开单赠送金+总的邀请奖励金 (后端直接返回)
            return new trade_utils_lib_1.SafeDecimal(innerOrder.usdt_investment).toNumber();
        }
        return (_a = innerOrder.totalCost) !== null && _a !== void 0 ? _a : 0;
    }, [innerOrder.totalCost, innerOrder.usdt_investment, shouldPerformCalculation]);
    // 总利润(U)=账户总权益(quote)*当前quote/U价格-实际投资额(u)
    const totalProfit = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            if (isRunning) {
                // 保证金余额
                const marginBalanceD = new trade_utils_lib_1.SafeDecimal(innerOrder.margin_balance);
                // 开仓均价
                const agvPriceD = new trade_utils_lib_1.SafeDecimal(innerOrder.position_open_price);
                // 运行中的订单的未实现盈亏
                const pnl = new trade_utils_lib_1.SafeDecimal(curPrice).sub(agvPriceD).mul(new trade_utils_lib_1.SafeDecimal(innerOrder.position));
                return new trade_utils_lib_1.SafeDecimal(quoteCurPrice).mul(marginBalanceD.add(pnl)).minus(new trade_utils_lib_1.SafeDecimal(totalCost)).toNumber();
            }
            return new trade_utils_lib_1.SafeDecimal(innerOrder.closed_quote_price)
                .mul(new trade_utils_lib_1.SafeDecimal(innerOrder.unlock_quote_amount))
                .add(new trade_utils_lib_1.SafeDecimal(innerOrder.unlock_usdt_amount))
                .minus(new trade_utils_lib_1.SafeDecimal(totalCost))
                .toNumber();
        }
        return innerOrder.totalProfit;
    }, [
        curPrice,
        innerOrder.closed_quote_price,
        innerOrder.margin_balance,
        innerOrder.position,
        innerOrder.position_open_price,
        innerOrder.totalProfit,
        innerOrder.unlock_quote_amount,
        innerOrder.unlock_usdt_amount,
        isRunning,
        quoteCurPrice,
        shouldPerformCalculation,
        totalCost,
    ]);
    const totalProfitPercent = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            return new trade_utils_lib_1.SafeDecimal(totalProfit).div(new trade_utils_lib_1.SafeDecimal(totalCost)).mul(100).toNumber();
        }
        return _totalProfitPercent;
    }, [_totalProfitPercent, shouldPerformCalculation, totalCost, totalProfit]);
    return {
        totalCost,
        totalProfit,
        totalProfitPercent,
    };
};
exports.useGFLockedOrderBasicInfo = useGFLockedOrderBasicInfo;
const useGFLockedOrderInfo = (params) => {
    const { shouldPerformCalculation, exchangeOrder, curPrice, quoteCurPrice, profit: _profit, unRealizedProfit: _unRealizedProfit, totalProfitPercent: _totalProfitPercent, profitPercent: _profitPercent, unRealizedProfitPercent: _unRealizedProfitPercent, total_profit_percentage: _total_profit_percentage, grid_profit_percentage: _grid_profit_percentage, } = params;
    const innerOrder = TradeAPILib_1.TradeUtils.getInnerOrder(exchangeOrder);
    const isRunning = exchangeOrder.isRunning;
    // 动态保证金
    const extra_margin = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            return new trade_utils_lib_1.SafeDecimal(quoteCurPrice).mul(new trade_utils_lib_1.SafeDecimal(innerOrder.extra_margin)).toString();
        }
        return innerOrder.extra_margin;
    }, [innerOrder.extra_margin, quoteCurPrice, shouldPerformCalculation]);
    const { totalCost, totalProfit, totalProfitPercent } = (0, exports.useGFLockedOrderBasicInfo)({
        shouldPerformCalculation,
        exchangeOrder,
        curPrice,
        quoteCurPrice,
        totalProfitPercent: _totalProfitPercent,
    });
    // 当前网格利润(U)=当前网格利润(quote)*当前quote/U价格
    const profit = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            if (isRunning) {
                return new trade_utils_lib_1.SafeDecimal(_profit).mul(new trade_utils_lib_1.SafeDecimal(quoteCurPrice)).toNumber();
            }
            return new trade_utils_lib_1.SafeDecimal(_profit).mul(new trade_utils_lib_1.SafeDecimal(innerOrder.closed_quote_price)).toNumber();
        }
        return _profit;
    }, [_profit, innerOrder.closed_quote_price, isRunning, quoteCurPrice, shouldPerformCalculation]);
    const profitPercent = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            return new trade_utils_lib_1.SafeDecimal(profit).div(new trade_utils_lib_1.SafeDecimal(totalCost)).mul(100).toNumber();
        }
        return _profitPercent;
    }, [_profitPercent, profit, shouldPerformCalculation, totalCost]);
    const unRealizedProfit = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            return new trade_utils_lib_1.SafeDecimal(totalProfit).minus(new trade_utils_lib_1.SafeDecimal(profit)).toNumber();
        }
        return _unRealizedProfit;
    }, [_unRealizedProfit, profit, shouldPerformCalculation, totalProfit]);
    const unRealizedProfitPercent = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            return new trade_utils_lib_1.SafeDecimal(unRealizedProfit).div(new trade_utils_lib_1.SafeDecimal(totalCost)).mul(100).toNumber();
        }
        return _unRealizedProfitPercent;
    }, [_unRealizedProfitPercent, shouldPerformCalculation, totalCost, unRealizedProfit]);
    const total_profit_percentage = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            const totalPInUSDT = new trade_utils_lib_1.SafeDecimal(totalProfit);
            const _profitWithdrawn = new trade_utils_lib_1.SafeDecimal(innerOrder.profitWithdrawn);
            if (isRunning) {
                return totalPInUSDT.add(new trade_utils_lib_1.SafeDecimal(quoteCurPrice).mul(_profitWithdrawn)).div(totalCost).mul(100).toNumber();
            }
            return totalPInUSDT
                .add(new trade_utils_lib_1.SafeDecimal(innerOrder.closed_quote_price).mul(_profitWithdrawn))
                .div(totalCost)
                .mul(100)
                .toNumber();
        }
        return _total_profit_percentage;
    }, [
        _total_profit_percentage,
        innerOrder.closed_quote_price,
        innerOrder.profitWithdrawn,
        isRunning,
        quoteCurPrice,
        shouldPerformCalculation,
        totalCost,
        totalProfit,
    ]);
    const grid_profit_percentage = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            const P = new trade_utils_lib_1.SafeDecimal(innerOrder.gridProfit).add(new trade_utils_lib_1.SafeDecimal(innerOrder.profitWithdrawn));
            if (isRunning) {
                return new trade_utils_lib_1.SafeDecimal(quoteCurPrice).mul(P).div(totalCost).mul(100).toNumber();
            }
            return new trade_utils_lib_1.SafeDecimal(innerOrder.closed_quote_price).mul(P).div(totalCost).mul(100).toNumber();
        }
        return _grid_profit_percentage;
    }, [
        _grid_profit_percentage,
        innerOrder.closed_quote_price,
        innerOrder.gridProfit,
        innerOrder.profitWithdrawn,
        isRunning,
        quoteCurPrice,
        shouldPerformCalculation,
        totalCost,
    ]);
    const profitWithdrawn = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            if (isRunning) {
                return new trade_utils_lib_1.SafeDecimal(quoteCurPrice).mul(new trade_utils_lib_1.SafeDecimal(innerOrder.profitWithdrawn)).toNumber();
            }
            return new trade_utils_lib_1.SafeDecimal(innerOrder.closed_quote_price).mul(new trade_utils_lib_1.SafeDecimal(innerOrder.profitWithdrawn)).toNumber();
        }
        return Number(innerOrder.profitWithdrawn);
    }, [innerOrder.closed_quote_price, innerOrder.profitWithdrawn, isRunning, quoteCurPrice, shouldPerformCalculation]);
    return {
        totalCost,
        totalProfit,
        profit,
        unRealizedProfit,
        totalProfitPercent,
        profitPercent,
        unRealizedProfitPercent,
        total_profit_percentage,
        grid_profit_percentage,
        extra_margin,
        profitWithdrawn: Number(profitWithdrawn),
    };
};
exports.useGFLockedOrderInfo = useGFLockedOrderInfo;
